import { io } from 'socket.io-client';
const URL = process.env.REACT_APP_PROJECT === 'production' ? process.env.REACT_APP_SOCKET : 'http://localhost:4000';

export const socket = io(URL,{
    autoConnect: false, transports: ['websocket', 'polling']
  });